module.exports = __webpack_public_path__ + "static/ifood-837fe2629d1f83f0c226fc3527006ff2.png";